export const STAGES = [
  { v: "prospect", label: "Prospect", dot: "bg-slate-400" },
  { v: "simulation_envoyee", label: "Simulation envoyée", dot: "bg-sky-500" },
  { v: "devis_signe", label: "Devis signé", dot: "bg-indigo-500" },
  { v: "dossier_depose", label: "Dossier CEE déposé", dot: "bg-amber-500" },
  { v: "prime_versee", label: "Prime versée", dot: "bg-emerald-500" },
  { v: "perdu", label: "Perdu", dot: "bg-red-500" },
];
export const stageLabel = (v) => STAGES.find((s) => s.v === v)?.label || v;

export const ACTIVITY_TYPES = [
  { v: "note", label: "Note" },
  { v: "appel", label: "Appel" },
  { v: "email", label: "Email" },
  { v: "rdv", label: "RDV" },
];

export const partnerName = (partners, id) => (id ? partners.find((p) => p.id === id)?.name || "Partenaire" : "Genis Energie");

export const todayIso = () => new Date().toISOString().slice(0, 10);
